import z from "zod";

export const measurementStatementFormSchema = z.object({
	statement: z.enum(["remember", "without-charge", "included"]),
});

export type MeasurementStatementFormSchema = z.infer<typeof measurementStatementFormSchema>;
